import React, { useMemo, useRef, useContext } from "react";
import { DataTableContext } from "../Tabs/Overview";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import { newArchiveCampaigns } from "../../../Flux/Actions/MasterCampaignActions";
import ArchiveActivationConfirmationModal from "../../Modals/ArchiveActivationConfirmationModal";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import { ARCHIVE_REFRESH_REQUESTED_ORIGINATOR, ViewMasterCampaignsContext } from "..";

export default () => {
	// Define a ref that will be used to open and close the modal
	const dpRef = useRef();

	// Import various contexts
	const { checkboxSelections, dataProvider, dataTableApi } = useContext(DataTableContext);
	const { setArchiveRefreshRequested } = useContext(ViewMasterCampaignsContext);

	const handleArchive = () => {
		if (checkboxSelections) {
			const { selectedMasterCampaigns, selectedActivationCampaigns } = checkboxSelections;
			const postData = {
				ActionType: "archive",
				MasterCampaignID: selectedMasterCampaigns || [],
				CampaignID:
					selectedActivationCampaigns
						?.filter(({ masterCampaignId }) => !selectedMasterCampaigns?.includes(masterCampaignId))
						?.map(({ activationCampaignId }) => activationCampaignId) || []
			};
			newArchiveCampaigns(postData).then(() => {
				dataTableApi?.current?.rowSelectionManager?.tree?.selectNode?.(false);
				setTimeout(() => {
					dataProvider?.update?.();
				}, 1);
				setArchiveRefreshRequested(ARCHIVE_REFRESH_REQUESTED_ORIGINATOR.OVERVIEW_TAB);
			});
		}
	};

	const disabled = useMemo(() => {
		return checkboxSelections?.selectedActivationCampaigns?.length == 0 && checkboxSelections?.selectedMasterCampaigns?.length == 0;
	}, [checkboxSelections]);

	// Return a memoized object containing both of these components
	return useMemo(
		() => ({
			Trigger: () => (
				<Tooltip title="Archive" position={TOOLTIP_POSITION.BOTTOM}>
					<Button
						display={BUTTON_DISPLAY.ICON_BORDERED}
						size={BUTTON_SIZE.SMALL}
						icon={"icon-archive"}
						onClick={() => {
							dpRef?.current?.triggerOpenClose?.();
						}}
						disabled={disabled}
						id="archiveCampaignButton"
						data-tracking-id-alt="archive-campaigns-button"
					>
						Archive
					</Button>
				</Tooltip>
			),
			DisplayedComponent: () => {
				return (
					<ArchiveActivationConfirmationModal
						archiveConfirmationModal={(ref) => {
							dpRef.current = ref;
						}}
						onSubmit={handleArchive}
					/>
				);
			}
		}),
		[disabled, checkboxSelections]
	);
};
